import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";
import { UserStatus } from "Shared/types/EmployeeProfiles";
import { userStatusToColor } from "Shared/utils/dailypayStatusColor";

type Props = { partnerCanceledAt: string | null; userStatus: UserStatus };

const useStyles = makeStyles(theme => ({
  employmentStatusCell: {
    color: ({ partnerCanceledAt }: Props) =>
      partnerCanceledAt ? `${theme.palette.error.main} !important` : colors.black,
  },
  row: {
    cursor: "pointer",
    color: colors.black,
    backgroundColor: "inherit",
    "&:hover,&:focus": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
  },
  text: ({ userStatus }: Props) => ({
    color: userStatus === UserStatus.CANCELED ? theme.palette.grey[500] : "inherit",
    fontSize: 16,
  }),
  title: {
    textTransform: "capitalize",
  },
  statusCell: {
    color: ({ userStatus }: Props) => userStatusToColor(userStatus, theme),
    padding: theme.spacing(1, 5, 1, 2),
    textTransform: "capitalize",
  },
  payGroupCell: {
    marginBottom: 8,
  },
}));

export default useStyles;
